import { WidgetContainer } from '@uniqkey-frontend/shared-app';
import { GetRetentionPeriodResponse } from '@uniqkey-backend-organization-web/api-client';
import { memo } from 'react';
import GeneralRetentionPeriodWidgetContainer from '../GeneralRetentionPeriodWidgetContainer';

export interface IGeneralRetentionPeriodWidgetProps {
  retentionPeriodInDays: GetRetentionPeriodResponse['retentionPeriodInDays'];
  isLoading: boolean;
  isError: boolean;
}

const GeneralRetentionPeriodWidget = (props: IGeneralRetentionPeriodWidgetProps) => {
  const {
    retentionPeriodInDays, isLoading, isError,
  } = props;

  if (isError) {
    return null;
  }

  if (isLoading) {
    return (
      <WidgetContainer container withShadow minHeight={240} p={3} isLoading={isLoading} />
    );
  }

  return (
    <GeneralRetentionPeriodWidgetContainer
      retentionPeriodInDays={retentionPeriodInDays}
    />
  );
};

export default memo(GeneralRetentionPeriodWidget);
